import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface PaginationSizeSelectorProps {
  currentPageSize: number;
  onPageSizeChange: (newPageSize: number) => void;
}

const PaginationSizeSelector: React.FC<PaginationSizeSelectorProps> = ({
  currentPageSize,
  onPageSizeChange,
}) => {
  const pageSizes = [10, 25, 50, 100];

  const handlePageSizeChange = (event: SelectChangeEvent<number>) => {
    const newPageSize = event.target.value as number;
    onPageSizeChange(newPageSize);
  };

  const {t} = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        position: "relative",
        top: -40,
        marginRight: "350px",
        flexDirection: "row",
        columnGap: 10,
        alignItems: "center",
      }}
    >
      <Typography sx={{ fontSize: 14 }}>{t('screens.trips.agGrid.pageSize')}:</Typography>

      <FormControl style={{ width: 90 }}>
        <Select
          labelId="pagination-size-label"
          id="pagination-size-selector"
          value={currentPageSize}
          onChange={handlePageSizeChange}
          style={{ fontSize: 14, height: 32 }}
        >
          {pageSizes.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default PaginationSizeSelector;
